import CardBlack from "./CardBlack"
import CardRed from "./CardRed"

const Mnemonica = () => {
    return (
        <div>
            <h2 className="text-2xl font-semibold">Mnemonica Stack</h2>
            <div className="columns-4">
                <div className="columns-1">
                    <CardBlack text="1C" number="1" />
                    <CardRed text="2H" number="2" />
                    <CardRed text="7D" number="3" />
                    <CardBlack text="3C" number="4" />
                    <CardRed text="4H" number="5" />
                    <CardRed text="6D" number="6" />
                    <CardBlack text="AS" number="7" />
                    <CardRed text="5H" number="8" />
                    <CardBlack text="9S" number="9" />
                    <CardBlack text="2S" number="10" />  
                    <CardRed text="QH" number="11" />
                    <CardRed text="3D" number="12" />
                    <CardBlack text="QC" number="13" />
                </div>
                <div className="columns-1">
                    <CardRed text="8H" number="14" />
                    <CardBlack text="6S" number="15" />
                    <CardBlack text="5S" number="16" />
                    <CardRed text="9H" number="17" />
                    <CardBlack text="KC" number="18" />
                    <CardRed text="2D" number="19" />
                    <CardRed text="JH" number="20" />
                    <CardBlack text="3S" number="21" />
                    <CardBlack text="8S" number="22" />
                    <CardRed text="6H" number="23" />  
                    <CardBlack text="10C" number="24" />
                    <CardRed text="5D" number="25" />
                    <CardRed text="KD" number="26" />
                </div>
                <div className="columns-1">
                    <CardBlack text="2C" number="27" />
                    <CardRed text="3H" number="28" />
                    <CardRed text="8D" number="29" />
                    <CardBlack text="5C" number="30" />
                    <CardBlack text="KS" number="31" />
                    <CardRed text="JD" number="32" />
                    <CardBlack text="8C" number="33" />
                    <CardBlack text="10S" number="34" />
                    <CardRed text="KH" number="35" />
                    <CardBlack text="JC" number="36" />
                    <CardBlack text="7S" number="37" />
                    <CardRed text="10H" number="38" />
                    <CardRed text="AD" number="39" />
                </div>
                <div className="columns-1">
                    <CardBlack text="4S" number="40" />
                    <CardRed text="7H" number="41" />
                    <CardRed text="4D" number="42" />
                    <CardBlack text="AC" number="43" />
                    <CardBlack text="9C" number="44" />
                    <CardBlack text="JS" number="45" />
                    <CardRed text="QD" number="46" />
                    <CardBlack text="7C" number="47" />
                    <CardBlack text="QS" number="48" />
                    <CardRed text="10D" number="49" />
                    <CardBlack text="6C" number="50" />
                    <CardRed text="AH" number="51" />
                    <CardRed text="9D" number="52" />
                </div>
            </div>
        </div>
    )
}

export default Mnemonica
